module.exports = __webpack_public_path__ + "img/disposalexplosion-min.1e3a23cc.jpg";